import { Field, useFormikContext } from 'formik';
import { Link } from 'react-router-dom';
import Address from 'src/components/util/Address';
import AgreedToTermsCheckbox from 'src/components/util/AgreedToTermsCheckbox';
import DataPrivacyNotice from 'src/components/util/DataPrivacyNotice';
import MuiValidTextField from 'src/components/util/MuiValidTextField';
import Section from 'src/components/util/Section';
import Subheader from 'src/components/util/Subheader';
import { BUSINESS_OWNER_INFO } from 'src/data/BusinessOwnerInfo/contant';
import formatPhoneNumber from 'src/util/formatPhoneNumber';

export default function BusinessOwnerInfo() {
  const { setFieldValue, errors } = useFormikContext();

  const handleChange = (field) => (e) => {
    setFieldValue(field, e.target.value);
  };
  const handleChangePhone = (field) => (e) => {
    setFieldValue(field, formatPhoneNumber(e.target.value));
  };

  return (
    <Section title="Business / Owner Information">
      <Subheader>Business Information</Subheader>
      {BUSINESS_OWNER_INFO.busInfoFields.map(({ label, name, type }, index) => (
        <Field
          InputLabelProps={{ shrink: true }}
          component={MuiValidTextField}
          label={label}
          key={index}
          name={name}
          onChange={type !== 'tel' ? handleChange(name) : handleChangePhone(name)}
          type={type}
        />
      ))}

      <Subheader>Business Address</Subheader>
      <Address fieldNames={BUSINESS_OWNER_INFO.busAddressFields} />

      <Subheader>Mailing Address</Subheader>
      <Address fieldNames={BUSINESS_OWNER_INFO.mailAddressFields} />

      <Subheader>Owner Information</Subheader>
      {BUSINESS_OWNER_INFO.ownerInfoFields.map(
        ({ label, name, multiline, placeholder, rows, type, variant }, index) => (
          <Field
            InputLabelProps={{ shrink: true }}
            component={MuiValidTextField}
            label={label}
            multiline={multiline}
            key={index}
            name={name}
            onChange={type !== 'tel' ? handleChange(name) : handleChangePhone(name)}
            placeholder={placeholder}
            type={type}
            rows={rows}
            variant={variant}
          />
        )
      )}
      <p>
        Note - The Office of the County Assessor is authorized to reduce the penalty imposed by Utah
        Code &sect; 59-2-307(1) to zero dollars ($0.00) if the tax amount for the subject year is
        two thousand five hundred dollars ($2,500.00) or less.
      </p>
      <p>
        All other requests must be processed under{' '}
        <Link
          className="font-medium text-blue-600 hover:underline dark:text-blue-500"
          to={`/processing-requests`}
          rel="noreferrer"
          target="_blank"
        >
          Section 21-8-2(A)
        </Link>{' '}
        of Utah County Code.
      </p>
      <p className="text font-medium">
        This appeal is due by the same date that is on your Personal Property Tax Notice.
      </p>
      <DataPrivacyNotice />

      <Subheader>By submitting this document, I declare the following: </Subheader>

      <AgreedToTermsCheckbox
        label="I have verified that the information entered above is correct. I understand and acknowledge to comply with all Utah County and Utah State requirements to request an appeal for my personal property."
        name="business.agreedToTerms"
        errorMessage={errors?.business?.agreedToTerms}
      />
    </Section>
  );
}
